// @flow

import {mapValues} from 'lodash';

export const formatDate = (newValue: string, oldValue: string): string => {
  const nv = newValue.replaceAll(/[^0-9.]/g, '');

  if (nv.length > 10) {
    return oldValue;
  }

  if (
    nv.length > oldValue.length &&
    /*
     * @see FBO-1995: Safari can't understand look behind notation and crashes
     * Before: nv.match(/(^[\d]{2}|[.][\d]{2})(?<!.{6})$/)
     *
     * @TODO: Discuss if that whole logic makes sense as it's probably causing more issues than doing good.
     */
    /(?:^\d{2}|\.\d{2})(?!.{6})$/.test(nv) &&
    !/^\d{2}\.\d{2}\.\d{2}$/.test(nv)
  ) {
    return `${nv}.`;
  }

  return nv;
};

export const formatLength = (n: number, s: string): string => s.slice(0, Math.max(0, n));

export const stripSpaces = (value: string): string => value.replaceAll(/\s+/g, '');

export const replaceEmptyStringsWithUndefined = (object: {
  [key: string]: string,
}): {[key: string]: string} => {
  return mapValues(object, (value) => (value === '' ? undefined : value));
};
